import type { FilterTimeType } from '@/app/types/Filter';

import { useAppDispatch } from '@/app/hooks/useAppDispatch';
import { useAppSelector } from '@/app/hooks/useAppSelector';
import { selectPeriod } from '@/app/slices/Filter';

export const usePageTimeFilter = () => {
	const {
		timeType = 'daily',
		startTime = '',
		endTime = '',
	} = useAppSelector((state) => state.filter);

	const dispatch = useAppDispatch();

	const onChange = (value: { timeType: FilterTimeType; startTime: string; endTime: string }) => {
		dispatch(selectPeriod(value));
	};

	return [{ timeType, startTime, endTime }, onChange] as const;
};
